import React, { useEffect } from "react";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import Footer from "../Component/Footer/Footer";
import Communitynew from "Pages/Community/Communitynew";
import Header from "../Component/Header/Header";
import { Col, Container, Row } from "react-bootstrap";
import { Input } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getTopMuseum } from "store/actions";
import CustomArtForm from "Pages/CustomArt/Custom-art-form";
export default function TopCollectionCustomArt() {

  return (
    <>
      <div className="position-relative">
        <Header />
        <div className="gradientBg">
          <div className="container-fluid profileBox communitybanner customArtprofile">
            <Row className="mb-4">
              <Col className="text-center" lg={12}>
                <h1 className="text-center p-0">Bring your idea of art to life </h1>
                <p className="text-center white-text-custom-art text-white">
                  Commission bespoke artwork tailored to your unique style and space. From concept to <br />
creation, we craft masterpieces that resonate with you
                </p>
              </Col>
            </Row>
          </div>
          </div>
          <section className="upcoming-section browseCategory position-relative pb-3">
            <Container>
              {/* <Row>
                <Col lg={12}>
                  <Row className="justify-content-center">
                    <Col lg={7}>
                      <div className="catesearch position-relative">
                        <Input
                          className="categorySearch"
                          placeholder="Search..."
                        />
                        <button>
                          <i className="fa-light fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row> */}
              <Row>
                <Col className="mt-5" lg={12}>
                  {/* <Communitynew /> */}
                  <CustomArtForm />
                </Col>             
              </Row>
            </Container>
          </section>
       
      </div>
    <Footer />
    </>
  );
}
